import { HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { OnBoardingVideoDto } from '@app/data/dtos/on-boarding-video/on-boarding-video.dto';
import { mapOnBoardingVideo } from '@app/data/mappers/on-boarding-video/on-boarding-video.mapper';
import { OnBoardingVideoRepository } from '@app/domain/repositories/on-boarding-video.repository.contract';
import { OnBoardingType, OnBoardingVideoType } from '@app/entities/interfaces/user/user-onboarding.interface';
import { OnBoardingVideo } from '@app/entities/models/on-boarding-video/on-boarding-video.model';
import { ENV } from '@environment';
import { SECTION_KEY } from '@services/interceptors/error-sections.interceptor/error-sections.interceptor';

import { MRepository } from '@mercadona/core/utils/repository';

@Injectable({
  providedIn: 'root'
})
export class OnBoardingVideoRepositoryImpl extends MRepository implements OnBoardingVideoRepository {
  constructor() {
    super(`${ENV.API_URL}`);
  }

  getOnBoardingVideo(
    companyCode: string,
    type: OnBoardingType,
    videoType: OnBoardingVideoType
  ): Observable<OnBoardingVideo[]> {
    let params = new HttpParams();
    params = params.set('company_code', companyCode);
    params = params.set('type', type);
    params = params.set('step', videoType);

    return this.get<OnBoardingVideoDto[]>(`/content/onboarding`, {
      params,
      context: new HttpContext().set(SECTION_KEY, 'onboarding-videos')
    }).pipe(map((videos) => videos.map(mapOnBoardingVideo)));
  }
}
